module.exports = __webpack_public_path__ + "static/img/gkjypng.287e19c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gkjypng.png
// module id = n40y
// module chunks = 1